import { getMainDomain } from '@nami/utils'
import { LanguageType } from '@/constants/language'

export function getCookie(key: string) {
    const cookie: Record<string, string> = {}
    document.cookie.split(';').forEach((el) => {
        const [key, value] = el.split('=')
        cookie[key.trim()] = value
    })
    return cookie[key]
}

export function getCookieLanguageType() {
    const lang = getCookie('lang')
    return lang ? (lang.replace('-', '_') as LanguageType) : LanguageType.EN
}

export function setCookie(key: string, value: string) {
    document.cookie = `${key}=${value}; domain=.${getMainDomain()}; path=/`
}
